module.exports = __webpack_public_path__ + "img/8.dd024e1a.jpg";